import type { NavigationHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/navigation';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';

const PAGE = 'features:auth.pages.common' satisfies I18nPrefix;

type ReturnToLoginLinkProps = {
  navigationHandler: NavigationHandlerContract;
  className?: string;
};

export function ReturnToLoginLink({
  navigationHandler,
  className = 'max-w pt-8 text-gray-600 text-sm md:pb-12',
}: ReturnToLoginLinkProps) {
  return (
    <p className={className}>
      <button
        type="button"
        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500"
        onClick={() =>
          navigationHandler.navigate('/login', { excludeSiteId: true, excludeSiteEnv: true })
        }
      >
        <span aria-hidden="true">← </span>
        {t(`${PAGE}.return_to_login`)}
      </button>
    </p>
  );
}
